"use client"

import { useUser } from "@auth0/nextjs-auth0"
import Image from "next/image"
import React from "react"

export default function LowerMenuItemDetails() {
    const { user } = useUser()

    if (!user) {
        return (
            <>
                <div className="bg-primary-700 size-8 animate-pulse rounded-full"></div>
                <div className="bg-primary-700 h-8 w-40 animate-pulse rounded-md"></div>
            </>
        )
    }

    return (
        <>
            <Image
                className="bg-primary-700 size-8 rounded-full"
                src={user?.picture || ""}
                alt=""
                width={32}
                height={32}
            />
            <span className="sr-only">Your profile</span>
            <span aria-hidden="true" className="truncate">
                {user?.name}
            </span>
        </>
    )
}
